export const emptyVips =
  [{
    id: "",
    type: "",
    title: "",
    description: "",
    endblock: "",
    eta: "",
    actions: ""
  }];

/* example
"id": "107",
"type": "Normal",
"title": "VIP-107 Payment Issuance to Binance Oracle", 
"description": "**Summary**\n\nThis VIP will transfer the sum of 2,550.00 BUSD to Binance Cloud On Chain Technologies Limited.\n\n\n**Background**\n\nThis payment is being issued against invoice #2023.A31 received on April 10th 2023 for payment of the Venus customization development work already realized by the Binance Oracle team for the integration work of various new price feeds in view of Venus launching its new Isolated Markets feature as part of the major Venus v4 protocol upgrade.  \n\nTotal to be paid in this VIP: BUSD 2,550.00\n", 
"endblock": 27348966, 
"eta": 1681499709, 
"actions": ["0xf322942f644a996a617bd29c16bd7d231d9f35e9.withdrawTreasuryBEP20(0xe9e7cea3dedca5984780bafc599bd69add087d56, 2550000000000000000000, 0x9c492e6c087b50f9191e671b6781be81579942ab)"]
*/
